export const metadataData = {
  appName: 'Celestia Nebula',
  title: 'Celestia Nebula | Monitoring and Management Platform',
  url: 'https://nebula.theiceji.com',
  description:
    'Celestia services monitoring and management platform. It provides a comprehensive overview of your Celestia services, allowing you to monitor their status, performance, and health in real-time.',
  coverImg: '/og.jpg',
  author: 'Jirayu Ninlapun (TheIceJi)',
  keywords: [
    'TheIceJi',
    'Jirayu Ninlapun',
    'Web Developer',
    'Creative Developer',
    'NextJs Developer',
    'ThreeJs',
    'GLSL',
    'Professional',
    'DimensionsAI',
    'Graphics Designer',
    'VFX Artist',
    'Sound Engineer',
    'ไอซ์จิ',
    'จิรายุ นิลพันธุ์',
    'IceJiVerse',
    'Celestia',
    'Cosmos',
    'Nexus',
    'Web3',
    'Nebula',
    'Stella',
    'InterLink',
    'Astra',
  ],
  twitterID: '@twitterId',
}
